// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import React from 'react';

import * as analytics from 'analytics/Analytics';
import FileStates from 'FileStates';
import {SequenceFileState} from 'FileStates';
import notifications from 'notifications';
import * as LoadingScreen from 'ui-library/LoadingScreen';
import Modal from 'ui-library/modals/Modal';

import CreateSequenceStep from '../CreateSequenceStep';
import HRTemplateModal from './HRTemplateModal';

interface Props {
  onRequestClose: () => void;
}

interface State {
  sequence: null | {
    id: string;
    name: string;
    activeVersionId: number;
    folderId: string;
  };
  loading: boolean;
  genome?: string | null;
}

class ImportSequenceForHRTemplateModal extends React.Component<Props, State> {
  _isMounted!: boolean;
  override state: State = {
    sequence: null,
    loading: false,
  };

  sequenceStepRef = React.createRef<CreateSequenceStep>();

  override componentDidMount(): void {
    this._isMounted = true;
  }

  override componentWillUnmount(): void {
    this._isMounted = false;
  }

  _handleSubmit = (): void => {
    const deferred = this.sequenceStepRef.current!.createSequence();
    if (!deferred) {
      return;
    }

    this.setState({loading: true});
    LoadingScreen.show();

    Promise.resolve(deferred)
      .then((sequenceId: string) => {
        if (this._isMounted) {
          return FileStates.get().openFolderItem(sequenceId, {open: true, source: 'crispr-analysis'});
        } else {
          return undefined;
        }
      })
      .then((fileState: SequenceFileState | undefined) => {
        if (this._isMounted && fileState) {
          const sequenceModel = fileState.model();
          const genome = this.sequenceStepRef.current!.getGenome();
          this.setState({
            sequence: {
              id: sequenceModel.id,
              name: sequenceModel.name(),
              activeVersionId: sequenceModel.getActiveVersionId(),
              // TODO(T2222): change to folder.id
              folderId: sequenceModel.folder()!.api_identifier,
            },
            genome: genome ? genome.ensemblName : null,
          });
          analytics.track('hr_template', 'imported_sequence_from_modal');
        }
      })
      .catch(notifications.notifyError)
      .finally(() => {
        this.setState({loading: false});
        LoadingScreen.hide();
      });
  };

  override render(): JSX.Element {
    if (!this.state.sequence) {
      const buttons = [
        {
          text: this.state.loading ? 'Importing...' : 'Import',
          submit: true,
          disabled: this.state.loading,
        },
      ];
      return (
        <Modal
          enableRedesign={true}
          title="Import sequence"
          onRequestSubmit={this._handleSubmit}
          onRequestClose={this.props.onRequestClose}
          buttons={buttons}
        >
          <CreateSequenceStep ref={this.sequenceStepRef} />
        </Modal>
      );
    }
    return (
      <HRTemplateModal
        onRequestClose={this.props.onRequestClose}
        sequence={this.state.sequence}
        initialGenome={this.state.genome}
        useCurrentSequence={true}
      />
    );
  }
}

export default ImportSequenceForHRTemplateModal;
